import clsx from 'clsx';
import Image from 'next/image';

type ExceptionType = 'default' | 'accessDenied' | 'noCoupon' | 'noData' | 'noMessage' | 'noOrder' | 'noSearch' | 'pageLost' | 'timeOut';

interface Props extends React.PropsWithChildren {
  type?: ExceptionType;
  msg?: string | React.ReactNode;
  className?: string;
}

export default function Exception({ type = 'default', msg, className, children }: Props) {
  const errImgMsgData: Record<string, { image: string; message: string | React.ReactNode }> = {
    default: {
      image: 'https://static.feewee.cn/mini/exception/dataFault.png',
      message: '暂无相关内容~',
    },
    accessDenied: {
      image: 'https://static.feewee.cn/mini/exception/accessDenied.png',
      message: '暂无访问权限~',
    },
    noCoupon: {
      image: 'https://static.feewee.cn/mini/exception/noCoupon.png',
      message: '暂无优惠券~',
    },
    noData: {
      image: 'https://static.feewee.cn/mini/exception/noData.png',
      message: '暂无相关数据~',
    },
    noMessage: {
      image: 'https://static.feewee.cn/mini/exception/noMessage.png',
      message: '暂无任何消息~',
    },
    noOrder: {
      image: 'https://static.feewee.cn/mini/exception/noOrder.png',
      message: '暂无订单~',
    },
    noSearch: {
      image: 'https://static.feewee.cn/mini/exception/noSearch.png',
      message: '暂无搜索结果~',
    },
    pageLost: {
      image: 'https://static.feewee.cn/mini/exception/pageLost.png',
      message: '页面走丢了~',
    },
    timeOut: {
      image: 'https://static.feewee.cn/mini/exception/timeOut.png',
      message: '当前网络不给力，请刷新页面~',
    },
  };

  return (
    <div className={clsx('h-screen bg-white text-center', className)}>
      <div className="mx-auto min-w-[375px] max-w-screen-2xl pt-48">
        <Image src={errImgMsgData[type].image} width={0} height={0} sizes="100vw" className="w-full" alt="img" />
        {msg && <div className="mt-10 text-sm text-gray-500 md1440:text-lg">{msg}</div>}
        {children}
      </div>
    </div>
  );
}
